import React from 'react';
import { FiCreditCard } from 'react-icons/fi';
import { BsCurrencyDollar, BsShield } from 'react-icons/bs';
import {FcDataConfiguration} from 'react-icons/fc';
import { MdPointOfSale, MdOutlineDashboard } from 'react-icons/md';


export const gridOrderImage = (props) => (
  <div>
    <img
      className="rounded-xl h-20 md:ml-3"
      src={props.ProductImage}
      alt="order-item"
    />
  </div>
);

export const gridOrderStatus = (props) => (
  <button
    type="button"
    style={{ background: props.StatusBg }}
    className="text-white py-1 px-2 capitalize rounded-2xl text-md"
  >
    {props.Status}
  </button>
);

const customerGridImage = (props) => (
  <div className="image flex gap-4">
    <div>
      <p>{props.CustomerName}</p>
      <p>{props.CustomerEmail}</p>
    </div>
  </div>
);

const customerGridStatus = (props) => (
  <div className="flex gap-2 justify-center items-center text-gray-700 capitalize">
    <p style={{ background: props.StatusBg }} className="rounded-full h-3 w-3" />
    <p>{props.Status}</p>
  </div>
);
export const areaPrimaryXAxis = {
  valueType: 'DateTime',
  labelFormat: 'y',
  majorGridLines: { width: 0 },
  intervalType: 'Years',
  edgeLabelPlacement: 'Shift',
  labelStyle: { color: 'gray' },
};

export const areaPrimaryYAxis = {
  labelFormat: '{value}%',
  lineStyle: { width: 0 },
  maximum: 4,
  interval: 1,
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
  labelStyle: { color: 'gray' },

};

export const colorMappingData = [
  [
    { x: 'Jan', y: 6.96 },
    { x: 'Feb', y: 8.9 },
    { x: 'Mar', y: 12 },
    { x: 'Apr', y: 17.5 },
    { x: 'May', y: 22.1 },
    { x: 'June', y: 25 },
    { x: 'July', y: 29.4 },
    { x: 'Aug', y: 29.6 },
    { x: 'Sep', y: 25.8 },
    { x: 'Oct', y: 21.1 },
    { x: 'Nov', y: 15.5 },
    { x: 'Dec', y: 9.9 },
  ],
  ['#FFFF99'],
  ['#FFA500'],
  ['#FF4040'],
];

export const rangeColorMapping = [
  { label: '1°C to 10°C',
    start: '1',
    end: '10',
    colors: colorMappingData[1] },

  { label: '11°C to 20°C',
    start: '11',
    end: '20',
    colors: colorMappingData[2] },

  { label: '21°C to 30°C',
    start: '21',
    end: '30',
    colors: colorMappingData[3] },

];

export const ColorMappingPrimaryXAxis = {
  valueType: 'Category',
  majorGridLines: { width: 0 },
  title: 'Months',
};

export const ColorMappingPrimaryYAxis = {
  lineStyle: { width: 0 },
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
  labelFormat: '{value}°C',
  title: 'Temperature',
};

export const FinancialPrimaryXAxis = {
  valueType: 'DateTime',
  minimum: new Date('2016, 12, 31'),
  maximum: new Date('2017, 9, 30'),
  crosshairTooltip: { enable: true },
  majorGridLines: { width: 0 },
};

export const FinancialPrimaryYAxis = {
  title: 'Price',
  minimum: 100,
  maximum: 180,
  interval: 20,
  lineStyle: { width: 0 },
  majorTickLines: { width: 0 },
};

export const LinePrimaryXAxis = {
  valueType: 'DateTime',
  labelFormat: 'y',
  intervalType: 'Years',
  edgeLabelPlacement: 'Shift',
  majorGridLines: { width: 0 },
  background: 'white',
};

export const LinePrimaryYAxis = {
  labelFormat: '{value}%',
  rangePadding: 'None',
  minimum: 0,
  maximum: 100,
  interval: 20,
  lineStyle: { width: 0 },
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
};

export const customersGrid = [
  { headerText: 'Cliente',
    width: '150',
    template: customerGridImage,
    textAlign: 'Center' },
  { field: 'ProjectName',
    headerText: 'Teléfono',
    width: '150',
    textAlign: 'Center' },
  { field: 'Status',
    headerText: 'Estado',
    width: '130',
    format: 'yMd',
    textAlign: 'Center',
    template: customerGridStatus },
  {
    field: 'Weeks',
    headerText: 'Cupo',
    width: '100',
    format: 'C2',
    textAlign: 'Center' },
  { field: 'Budget',
    headerText: 'Fiado',
    width: '100',
    format: 'yMd',
    textAlign: 'Center' },

  { field: 'Location',
    headerText: 'Última Compra',
    width: '150',
    textAlign: 'Center' },
  { field: 'CustomerID',
    headerText: 'Rut',
    width: '120',
    textAlign: 'Center',
    isPrimaryKey: true,
  },

];

export const employeesGrid2 = [
  { field: 'EmployeeID',
  headerText: 'Cliente',
  width: '180',
  textAlign: 'Rigth' },
  { field: 'HireDate',
    headerText: 'Fecha',
    width: '120',
    textAlign: 'Left',
  },
  { field: 'Title',
    headerText: 'Deuda',
    width: '170',
    textAlign: 'Left',
  },
  { field: 'Name',
  headerText: 'Abonos',
  width: '135',
  textAlign: 'Center' },
  { field: 'ReportsTo',
    headerText: 'Saldos',
    width: '120',
    textAlign: 'Center' }
];

export const employeesGrid = [
  { field: 'EmployeeID',
  headerText: 'Voucher',
  width: '120',
  textAlign: 'Rigth' },
  { field: 'EmployeeID',
  headerText: 'Boleta SII',
  width: '120',
  textAlign: 'Rigth' },
  { field: 'HireDate',
    headerText: 'Fecha - Hora',
    width: '170',
    textAlign: 'Left',
  },
  { field: 'Title',
    headerText: 'Monto',
    width: '170',
    textAlign: 'Left',
  },
  { field: 'Name',
  headerText: 'Pago',
  width: '135',
  textAlign: 'Center' },
  { field: 'ReportsTo',
    headerText: 'Vendedor',
    width: '120',
    textAlign: 'Center' }
];


export const links = [
  {links:[
      {
        name: 'Mi Biopanel',
        icon: <MdOutlineDashboard />,
      },
  ]},
  {
    title: 'Operación',
    links: [
      {
        name: 'registro recepción',
        icon: <MdPointOfSale />,
      },
      {
        name: 'registro salidas',
        icon: <MdPointOfSale />,
      },
      {
        name: 'programar rutas',
        icon: <MdPointOfSale />,
      },
      {
        name: 'registro pagos',
        icon: <MdPointOfSale />,
      },
      {
        name: 'Registro Clientes',
        icon: <MdPointOfSale />,
      },
    ],
  },
  {
    title: 'Reportes',
    links: [
      {
        name: 'retiros por partner',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'reporte pagos',
        icon: <MdOutlineDashboard />,
      },
    ],
  },
  {
    title: 'Configuración',
    links: [
      {
        name: 'maestros',
        icon: <FcDataConfiguration />,
        children: [
          { name: "puntos drop off", icon: <FcDataConfiguration /> },
          { name: "centros compostaje", icon: <FcDataConfiguration /> },
          { name: "clientes", icon: <FcDataConfiguration /> },
          { name: "partners", icon: <FcDataConfiguration /> },
          { name: "planes suscripción", icon: <FcDataConfiguration /> },
        ],
      },
      {
        name: 'parametros',
        icon: <FcDataConfiguration />,
        children: [
          { name: "usuarios", icon: <FcDataConfiguration /> },
          { name: "comunas", icon: <FcDataConfiguration /> },
          { name: "parametros", icon: <FcDataConfiguration /> },
        ],
      },
    ],
  },
];


export const linksDropoff = [
  {
    links: [
      {
        name: 'Mi Biopanel',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'registro recepción',
        icon: <MdPointOfSale />,
      },
      {
        name: 'información planes',
        icon: <MdPointOfSale />,
      },
    ],
  },
];

export const linksPartner = [
  {
   links: [{
        name: 'Mi Biopanel',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'programar rutas',
        icon: <MdPointOfSale />,
      },
      {
        name: 'retiros',
        icon: <MdOutlineDashboard />,
      },
      {
      name: 'información planes',
      icon: <MdPointOfSale />,
      },
      {
        name: 'Registrar Cliente',
        icon: <MdPointOfSale />,
      },
    ]
  }
];

export const linksCliente = [
  {
    links: [{
      name: 'Mi Biopanel',
      icon: <MdOutlineDashboard />,
    },
    {
      name: 'planes y servicios',
      icon: <MdPointOfSale />,
    },
    {
      name: 'pagos',
      icon: <MdPointOfSale />,
    },
    {
      name: 'ayuda',
      icon: <MdPointOfSale />,
    },
  ]}
];

export const themeColors = [
  {
    name: 'blue-theme',
    color: '#1A97F5',
  },
  {
    name: 'green-theme',
    color: '#03C9D7',
  },
  {
    name: 'purple-theme',
    color: '#7352FF',
  },
  {
    name: 'red-theme',
    color: '#FF5C8E',
  },
  {
    name: 'indigo-theme',
    color: '#1E4DB7',
  },
  {
    color: '#FB9678',
    name: 'orange-theme',
  },
];

export const userProfileData = [
  {
    icon: <BsCurrencyDollar />,
    title: 'My Profile',
    desc: 'Account Settings',
    iconColor: '#03C9D7',
    iconBg: '#E5FAFB',
  },
  {
    icon: <BsShield />,
    title: 'My Inbox',
    desc: 'Messages & Emails',
    iconColor: 'rgb(0, 194, 146)',
    iconBg: 'rgb(235, 250, 242)',
  },
  {
    icon: <FiCreditCard />,
    title: 'My Tasks',
    desc: 'To-do and Daily Tasks',
    iconColor: 'rgb(255, 244, 229)',
    iconBg: 'rgb(254, 201, 15)',
  },
];

export const ordersGrid = [
  {
    field: 'codigoProducto',
    headerText: 'Código',
    width: '100',
    textAlign: 'Left',
  },
  {
    field: 'categoria',
    headerText: 'Categoria',
    width: '100',
    textAlign: 'Left',
  },
  {
    field: 'marca',
    headerText: 'Marca',
    width: '100',
    textAlign: 'Left',
  },
  {
    field: 'descripcionProducto',
    headerText: 'Producto',
    width: '170',
    editType: 'dropdownedit',
    textAlign: 'Center',
  },
  {
    field: 'formato',
    headerText: 'Formato',
    width: '150',
    textAlign: 'Center',
  },
  {
    headerText: 'Stock',
    template: gridOrderStatus,
    field: 'stock',
    textAlign: 'Center',
    width: '120',
  },
  {
    field: 'precioCompra',
    headerText: 'Precio Compra',
    format: 'C2',
    textAlign: 'Center',
    editType: 'numericedit',
    width: '150',
  },
  {
    field: 'precioVenta',
    headerText: 'Precio Venta',
    format: 'C2',
    textAlign: 'Center',
    editType: 'numericedit',
    width: '150',
  },
  {
    field: 'margen',
    headerText: 'margen',
    format: 'C2',
    textAlign: 'Center',
    editType: 'numericedit',
    width: '150',
  }
];

export const ordersGrid2 = [
  {
    field: 'fecha',
    headerText: 'Fecha',
    format: 'C2',
    textAlign: 'Center',
    editType: 'numericedit',
    width: '150',
  },
  {
    field: 'OrderID',
    headerText: 'Código',
    width: '100',
    textAlign: 'Center',
  },
  {
    field: 'OrderItems',
    headerText: 'Nombre Producto',
    width: '170',
    editType: 'dropdownedit',
    textAlign: 'Center',
  },
  {
    field: 'Location',
    headerText: 'Formato',
    width: '150',
    textAlign: 'Center',
  },
  {
    headerText: 'Stock',
    template: gridOrderStatus,
    field: 'OrderItems',
    textAlign: 'Center',
    width: '120',
  },
  {
    field: 'TotalAmount',
    headerText: 'Precio Compra',
    format: 'C2',
    textAlign: 'Center',
    editType: 'numericedit',
    width: '150',
  }
];


export const contextMenuItems = [
  'AutoFit',
  'AutoFitAll',
  'SortAscending',
  'SortDescending',
  'Copy',
  'Edit',
  'Delete',
  'Save',
  'Cancel',
  'PdfExport',
  'ExcelExport',
  'CsvExport',
  'FirstPage',
  'PrevPage',
  'LastPage',
  'NextPage',
];
